import { useEffect, useState } from 'react';
import { apiClient, authHeaders } from '../../../api/apiClient';
import { token } from '../../../api/api';
import {useTranslation} from "react-i18next";

const emptyArticle = {
    titleFr: '', titleEn: '', titleEs: '',
    contentFr: '', contentEn: '', contentEs: '',
};

export const NewsletterSection = () => {
    const [articles, setArticles] = useState<any[]>([]);
    const [form, setForm] = useState(emptyArticle);
    const [sending, setSending] = useState<number | null>(null);
    const {t} = useTranslation()

    const load = () =>
        apiClient.get('/newsletter/articles/articles', authHeaders(token()))
            .then((r: any) => setArticles(r.data));

    useEffect(() => { load(); }, []);

    const handleSubmit = async () => {
        await apiClient.post('/newsletter/articles/articles', form, authHeaders(token()));
        setForm(emptyArticle);
        load();
    };

    const handleSend = async (id: number) => {
        if (!window.confirm('Envoyer à toute la liste ?')) return;
        setSending(id);
        const r: any = await apiClient.post(`/newsletter/articles/articles/${id}/send`, {}, authHeaders(token()));
        alert(`Envoyé à ${r.data.sent} abonnés`);
        setSending(null);
        load();
    };

    const langs = [
        { key: 'Fr', label: t("languages.french") },
        { key: 'En', label: t("languages.english") },
        { key: 'Es', label: t("languages.spanish") },
    ];

    return (
        <div>
            <div className="admin-card">
                <p className="admin-section-title">Créer un article</p>
                {langs.map(({ key, label }) => (
                    <div key={key} className="admin-field" style={{ margin: '1rem' }}>
                        <label>{label}</label>
                        <input
                            type="text"
                            placeholder={`Titre ${label}`}
                            value={(form as any)[`title${key}`]}
                            onChange={e => setForm(f => ({ ...f, [`title${key}`]: e.target.value }))}
                        />
                        <textarea
                            placeholder={`Contenu ${label}`}
                            rows={4}
                            value={(form as any)[`content${key}`]}
                            onChange={e => setForm(f => ({ ...f, [`content${key}`]: e.target.value }))}
                            style={{ width: '100%', margin: '0.5rem' }}
                        />
                    </div>
                ))}
                <button className="btn-admin btn-admin-primary" onClick={handleSubmit}>
                    Créer l'article
                </button>
            </div>

            <div className="admin-card">
                <p className="admin-section-title">Articles</p>
                {articles.map(a => (
                    <div className={"admin-articles"} key={a.id} style={{ borderBottom: '1px solid #333', padding: '0.75rem 0' }}>
                        <strong># {a.id}</strong>
                        <u>{t("languages.french")}</u>
                        <strong>{a.titleFr}</strong>
                        <div>{a.contentFr}</div>
                        <u>{t("languages.spanish")}</u>
                        <strong>{a.titleEs}</strong>
                        <div>{a.contentEs}</div>
                        <u>{t("languages.english")}</u>
                        <strong>{a.titleEn}</strong>
                        <div>{a.contentEn}</div>
                        <div style={{ marginLeft: '1rem', fontSize: '0.8rem', color: '#888' }}>
                            {a.sentAt ? `Envoyé le ${new Date(a.sentAt).toLocaleDateString()}` : 'Non envoyé'}
                        </div>
                        {!a.sentAt && (
                            <button
                                className="btn-admin btn-admin-primary"
                                style={{ marginLeft: '1rem' }}
                                disabled={sending === a.id}
                                onClick={() => handleSend(a.id)}
                            >
                                {sending === a.id ? 'Envoi...' : 'Envoyer'}
                            </button>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
